<template>
<div class="odr-scrollable-content" :style="`max-height: ${height} !important;`">
    <slot></slot>
</div>
</template>
<script>
import '../styles/scrollable-content.scss'
export default {
    props: {
        height: {
            default: 'none',
            _descr: 'Set height of section',
        },
    },
}
</script>
